module.exports = __webpack_public_path__ + "img/multiplier.e14a8403.png";